// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h2","input":"h3","button":"h4"};